const fields = [
  {
    id: "location",
    type: "typeahead",
    label: "Location",
  },
];

export default fields;